export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/freeIcon.fa930376.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};